// extracted by mini-css-extract-plugin
module.exports = {"vars":"'../../vars.css'","gray":"#F5F5F5","secondary":"#C4942F","mainWrapper":"PageContent-module--mainWrapper--2obES","inner":"PageContent-module--inner--Dt76f"};